var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.permits && _vm.searchType === "permit"
    ? _c(
        "contentBox",
        { attrs: { noScrollFix: true, mainId: "permits" } },
        [
          _c("contentTitle", {
            attrs: {
              label: _vm.permits.length + " PERMITS",
              labelClass: "text-white"
            }
          }),
          _vm._v(" "),
          _c("contentBody", { attrs: { bg: "rgba(55,71,79,0.6)" } }, [
            _c(
              "div",
              { staticClass: "p-3" },
              [
                _vm.permits.length < 1
                  ? _c("div", { staticClass: "card no-hover mb-2 field-row" }, [
                      _c("div", { staticClass: "clearfix p-2" }, [
                        _c("strong", [_vm._v("No permits found")]),
                        _vm._v(" "),
                        _c("p", { staticClass: "mb-0" }, [
                          _vm._v(
                            "Try broadening your search or zooming out in the map"
                          )
                        ])
                      ])
                    ])
                  : _vm._l(_vm.permits, function(permit, index) {
                      return _c(
                        "div",
                        {
                          staticClass: "card mb-2 field-row",
                          class: _vm.getHighlightClass(permit),
                          on: {
                            mouseenter: function($event) {
                              return _vm.mouseenter($event, permit)
                            },
                            mouseleave: function($event) {
                              return _vm.mouseleave($event, permit)
                            },
                            click: function($event) {
                              return _vm.click($event, permit)
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "pt-2 mx-2 pb-1 font-weight-bold border-bottom-gray font-10 text-uppercase"
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(permit.typeRaw) +
                                  " \n\t\t\t\t\t"
                              ),
                              _vm.getStatusIsNew(permit)
                                ? _c("sup", { staticClass: "text-red" }, [
                                    _vm._v("New")
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", { staticClass: "float-right" }, [
                                permit && permit.link
                                  ? _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.jurisdictionPermitURL(
                                            permit
                                          ),
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t#" +
                                            _vm._s(
                                              permit.jurisdictionPermitId
                                            ) +
                                            "\n\t\t\t\t\t\t\t"
                                        ),
                                        _c(
                                          "i",
                                          {
                                            staticClass: "material-icons md-12"
                                          },
                                          [_vm._v("open_in_new")]
                                        )
                                      ]
                                    )
                                  : _c("span", [
                                      _vm._v(
                                        "#" +
                                          _vm._s(permit.jurisdictionPermitId)
                                      )
                                    ])
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "pt-2" }, [
                            permit.apn !== null
                              ? _c(
                                  "div",
                                  { staticClass: "clearfix pb-2 px-2" },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "mb-0 font-weight-light" },
                                      [_vm._v("Parcel APN")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "float-right font-weight-bold"
                                      },
                                      [
                                        !permit.parcelId
                                          ? _c("span", [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\tN/A\n\t\t\t\t\t\t\t"
                                              )
                                            ])
                                          : _c(
                                              "a",
                                              {
                                                attrs: { href: "javascript:" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.parcelGo(
                                                      $event,
                                                      permit.parcelId
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      _vm.formatAPN(permit.apn)
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            permit.projectName !== null
                              ? _c(
                                  "div",
                                  { staticClass: "clearfix pb-2 px-2" },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "mb-0 font-weight-light" },
                                      [_vm._v("Project name")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "float-right font-weight-bold"
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t" +
                                            _vm._s(permit.projectName) +
                                            "\n\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            permit.projectId !== null
                              ? _c(
                                  "div",
                                  { staticClass: "clearfix pb-2 px-2" },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "mb-0 font-weight-light" },
                                      [_vm._v("Project ID")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "float-right font-weight-bold"
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t" +
                                            _vm._s(permit.projectId) +
                                            "\n\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            permit.contractor &&
                            permit.contractor.companyName !== null
                              ? _c(
                                  "div",
                                  { staticClass: "clearfix pb-2 px-2" },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "mb-0 font-weight-light" },
                                      [_vm._v("Contractor")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "float-right font-weight-bold"
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              permit.contractor.companyName
                                            ) +
                                            "\n\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "clearfix pb-2 px-2" }, [
                              _c(
                                "label",
                                { staticClass: "mb-0 font-weight-light" },
                                [_vm._v("Status")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "float-right font-weight-bold" },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.getStatus(permit)) +
                                      " on " +
                                      _vm._s(_vm.getStatusDate(permit))
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            permit.description !== null
                              ? _c(
                                  "div",
                                  { staticClass: "clearfix pb-2 px-2" },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.descriptionShort(
                                              permit.description
                                            )
                                          ) +
                                          "\n\t\t\t\t\t\t"
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ])
                        ]
                      )
                    })
              ],
              2
            )
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49079f2c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49079f2c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/permit/permit-list.vue
// module id = null
// module chunks = 